$(window).on('load', function() {
// Moves Yotpo on mobile to above gallery image and reverts back if screen width is adjsuted
function adjustPosition(){
  let mobilePrice = $(".product-block--price.hide-desktop")
  let desktopPrice = $(".product-block--price.hide-mobile")
  if(window.innerWidth > 768){
    $(desktopPrice).append($('.yotpo.bottomLine'))
  }else{
    $(mobilePrice).append($('.yotpo.bottomLine'))
  }
}

  // Yotpo Reviews Wording
  setTimeout( () => {
    if ( $('.yotpo-no-reviews').length == 0 ) {
      let linkText = $('.yotpo.bottomLine .yotpo-bottomline.star-clickable a').text()
      $('.yotpo.bottomLine .yotpo-bottomline.star-clickable a').text(`READ ${linkText}`)
    }
    $('.yotpo.bottomLine').css('opacity', '1')
    // $('.yotpo.bottomLine').css('height', 'auto')
    adjustPosition()
    $(window).resize(function(){
      adjustPosition()
    })
  }, 200)
});